export default __webpack_public_path__ + "static/media/ToroClosed.9b8cd25c.jpg";